/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrUpdateVisitTripSchema } from '../models/CreateOrUpdateVisitTripSchema';
import type { VisitTripSchema } from '../models/VisitTripSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VisitTripsApi {
    /**
     * Create Visit Trip
     * Create new visit trip, <br>Required Permission: create_visit_trip
     * @returns VisitTripSchema Created
     * @throws ApiError
     */
    public static insuranceCreateVisitTripPost({
        visitId,
        requestBody,
    }: {
        visitId: string,
        requestBody: CreateOrUpdateVisitTripSchema,
    }): CancelablePromise<VisitTripSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/visit-trips/{visit_id}/',
            path: {
                'visit_id': visitId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Visit Trip List For Visit
     * Get visit trip list for visit, <br>Required Permission: get_visit_trip_list
     * @returns VisitTripSchema OK
     * @throws ApiError
     */
    public static insuranceGetVisitTripListForVisitGet({
        visitId,
    }: {
        visitId: string,
    }): CancelablePromise<Array<VisitTripSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/visit-trips/{visit_id}/',
            path: {
                'visit_id': visitId,
            },
        });
    }
    /**
     * Delete Visit Trip
     * Delete visit trip, <br>Required Permission: delete_visit_trip
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeleteVisitTripDelete({
        visitTripId,
    }: {
        visitTripId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/visit-trips/delete/{visit_trip_id}/',
            path: {
                'visit_trip_id': visitTripId,
            },
        });
    }
    /**
     * Update Visit Trip
     * Update visit trip, <br>Required Permission: update_visit_trip
     * @returns VisitTripSchema OK
     * @throws ApiError
     */
    public static insuranceUpdateVisitTripPut({
        visitTripId,
        requestBody,
    }: {
        visitTripId: string,
        requestBody: CreateOrUpdateVisitTripSchema,
    }): CancelablePromise<VisitTripSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/visit-trips/update/{visit_trip_id}/',
            path: {
                'visit_trip_id': visitTripId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
